// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__oz+4z","xxl":"Heading_xxl__oDJ3F","xl":"Heading_xl__Xe5oK","l":"Heading_l__9SwNa","m":"Heading_m__rKlst","s":"Heading_s__kupCs","xs":"Heading_xs__fuUT9"};